'use strict'

import axios from 'axios'
import qs from 'qs'
import utils from './utils'

import {
	Message
} from 'element-ui'
//请求拦截器
axios.interceptors.request.use(config => {
	// loading
	if (utils.getToken('token')) {
		// let each request carry token
		// ['X-Token'] is a custom headers key
		// please modify it according to the actual situation
		config.headers['baseModel'] = 'company';
		config.headers['apiCompanyToken'] = utils.getToken('token')
	}
	return config
}, error => {
	return Promise.reject(error)
})
//响应拦截器
axios.interceptors.response.use(response => {
	return response
}, error => {
	return Promise.resolve(error.response)
})
//判断http code码
function checkStatus(response) {
	// loading
	// 如果http状态码正常，则直接返回数据
	if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
		return response
		// 如果不需要除了data之外的数据，可以直接 return response.data
	}
	// 异常状态下，把错误信息返回去
	return {
		status: -404,
		msg: '网络异常'
	}
}
//判断接口返回数据
function checkCode(res) {
	// 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
	if (res.status === -404) {
		Message.error(res.data.msg)
		return Promise.reject(new Error(res.msg || 'Error'))
	}
	if (res.data.code !== 1000) {
		Message.warning(res.data.msg)
		return Promise.reject(new Error(res.data.msg || 'Error'))
	}

	if (res.data.code == 1000) {
		return res.data
	}

}

export default {
	post(url, data) {
		return axios({
			method: 'post',
			baseURL: process.env.VUE_APP_REQUEST_BASE_URL,
			url,
			data: qs.stringify(data),
			timeout: 15000,
			// headers: {}
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	get(url, params) {
		return axios({
			method: 'get',
			baseURL: process.env.VUE_APP_REQUEST_BASE_URL,
			url,
			params, // get 请求时带的参数
			timeout: 15000,
			// headers: {
			//   'X-Requested-With': 'XMLHttpRequest'
			// }
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	uploadPost(url, params) {
		return axios({
			method: 'post',
			baseURL: process.env.VUE_APP_REQUEST_BASE_URL,
			url,
			data: params,
			timeout: 15000,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	}
}
